import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Sparkles } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const { t } = useSettings();
  const id = params.get("id");

  useEffect(() => { document.title = "Order placed – Cheap4Teach"; }, []);

  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="order-success-page">
      <div className="inline-block">
        <CheckCircle2 className="w-20 h-20 text-[#00E0AA]" strokeWidth={2.5} />
      </div>
      <h1 className="text-4xl sm:text-5xl font-['Fredoka'] font-bold mt-4">{t("success.title", "Order Placed!")}</h1>
      <p className="c4t-desc text-base sm:text-lg mt-2 flex items-center justify-center gap-2">
        <Sparkles className="w-5 h-5 text-[#FFC500]" /> {t("success.subtitle", "Thank you, teacher! We'll be in touch soon.")}
      </p>
      {id && (
        <div className="c4t-card mt-8 inline-block">
          <span className="text-sm c4t-desc">Order Reference</span>
          <p className="font-['Fredoka'] font-bold text-xl" data-testid="order-id">{id.slice(0, 8).toUpperCase()}</p>
        </div>
      )}
      <p className="mt-6 c4t-desc">A confirmation email is on its way to you.</p>
      <Link to="/shop" className="mt-6 inline-flex c4t-btn c4t-btn-pink" data-testid="success-shop-more-btn">{t("success.cta", "Shop More")}</Link>
    </div>
  );
}
